<template>
  <div>
    <b-modal
      id="modal-updateAttributes"
      ref="updateAttributes"
      hide-footer
      centered
      title="Ajouter un attribut"
    >
      <div class="pl-lg-4">
        <div class="row">
          <div class="col-12">
            <div>
              <center>
                <b-form-input
                  type="text"
                  placeholder="Nom de l'attribut"
                  v-model="attributeName"
                  disabled
                ></b-form-input>
                <b-form-tags
                  placeholder="Ajouter des valeurs"
                  remove-on-delete
                  tag-pills
                  size="lg"
                  v-model="value"
                ></b-form-tags>
              </center>
            </div>
          </div>
        </div>
      </div>

      <hr class="my-4" />
      <center>
        <b-btn
          type="submit"
          style="background-color: #c2b59b; color: #fff"
          @click="updateAttribute"
          >Modifier</b-btn
        >
      </center>
    </b-modal>
    <GStockLoader :loading="loading" />
  </div>
</template>
<script>
import GStockLoader from "@/components/Loader";
import { put } from "@/mixins/api";
export default {
  name: "updateattribute",
  components: {
    GStockLoader,
  },
  data() {
    return {
      loading: false,
      modalupd: false,
      model: {
        id: "",
        name: "",
        attributes: [],
      },
      attributeName: "",
      value: [],
      previous: "",
    };
  },
  methods: {
    setId(id, name, attributes, attrName, currentValues, previous) {
      this.model.id = id;
      this.model.name = name;
      this.model.attributes = attributes;
      this.value = currentValues;
      this.attributeName = attrName;
      this.previous = previous;
      this.$refs.updateAttributes.show();
    },
    updateAttribute() {
      if (this.attributeName.length == 0) return;
      this.loading = true;
      if (this.value.length != 0)
        this.attributeName = this.attributeName + "~~" + this.value.join("~");
      this.model.attributes = this.model.attributes.filter(
        (x) => x != this.previous
      );
      const model = {
        id: this.model.id,
        name: this.model.name,
        attributes: [...this.model.attributes, this.attributeName].join(";"),
      };
      put("stp", model)
        .then((resp) => {
          this.$emit("updated");
          this.$refs.updateAttributes.hide();
        })
        .finally(() => {
          this.loading = false;
        });

      this.modalupd = true;
    },
  },
  mounted() {},
};
</script>
<style>
#modal-updateAttributes li {
  padding: 5px !important;
  color: blue !important;
  font-size: 14px !important;
}
</style>      